import React from 'react'

import LinkExternoFormPageContainer from './LinkExternoFormPageContainer'

export class LinkExternoFormPage extends React.Component {
  render() {
    return <LinkExternoFormPageContainer {...this.props} />
  }
}
